import { ResponseStream } from "./internal/response-stream.js";

//#region src/api/request-output-context.ts
/**
* Utility function to merge headers from multiple sources.
* Later headers override earlier ones.
*/
function mergeHeaders(...headerSources) {
	const mergedHeaders = new Headers();
	for (const headerSource of headerSources) {
		if (!headerSource) continue;
		if (headerSource instanceof Headers) for (const [key, value] of headerSource.entries()) mergedHeaders.set(key, value);
		else if (Array.isArray(headerSource)) for (const [key, value] of headerSource) mergedHeaders.set(key, value);
		else for (const [key, value] of Object.entries(headerSource)) mergedHeaders.set(key, value);
	}
	return mergedHeaders;
}
var OutputContext = class {
	/**
	* Creates an error response.
	*
	* Shortcut for `throw new FragnoApiError(...)`
	*/
	error = ({ message, code }, initOrStatus, headers) => {
		if (typeof initOrStatus === "undefined") return Response.json({
			message,
			code
		}, {
			status: 500,
			headers
		});
		if (typeof initOrStatus === "number") return Response.json({
			message,
			code
		}, {
			status: initOrStatus,
			headers
		});
		const mergedHeaders = mergeHeaders(initOrStatus.headers, headers);
		return Response.json({
			message,
			code
		}, {
			status: initOrStatus.status,
			headers: mergedHeaders
		});
	};
	empty = (initOrStatus, headers) => {
		const defaultHeaders = {};
		if (typeof initOrStatus === "undefined") {
			const mergedHeaders$1 = mergeHeaders(defaultHeaders, headers);
			return new Response(null, {
				status: 201,
				headers: mergedHeaders$1
			});
		}
		if (typeof initOrStatus === "number") {
			const mergedHeaders$1 = mergeHeaders(defaultHeaders, headers);
			return new Response(null, {
				status: initOrStatus,
				headers: mergedHeaders$1
			});
		}
		const mergedHeaders = mergeHeaders(defaultHeaders, initOrStatus.headers, headers);
		return new Response(null, {
			status: initOrStatus.status,
			headers: mergedHeaders
		});
	};
	json = (object, initOrStatus, headers) => {
		if (typeof initOrStatus === "undefined") return Response.json(object, {
			status: 200,
			headers
		});
		if (typeof initOrStatus === "number") return Response.json(object, {
			status: initOrStatus,
			headers
		});
		const mergedHeaders = mergeHeaders(initOrStatus.headers, headers);
		return Response.json(object, {
			status: initOrStatus.status,
			headers: mergedHeaders
		});
	};
	jsonStream = (cb, { onError, headers } = {}) => {
		const defaultHeaders = {
			"content-type": "application/x-ndjson; charset=utf-8",
			"transfer-encoding": "chunked",
			"cache-control": "no-cache"
		};
		const { readable, writable } = new TransformStream();
		const stream = new ResponseStream(writable, readable);
		(async () => {
			try {
				await cb(stream);
			} catch (e) {
				if (e === void 0) {} else if (e instanceof Error && onError) await onError(e, stream);
				else console.error(e);
			} finally {
				stream.close();
			}
		})();
		return new Response(stream.responseReadable, {
			status: 200,
			headers: mergeHeaders(defaultHeaders, headers)
		});
	};
};
var RequestOutputContext = class extends OutputContext {
	#outputSchema;
	constructor(outputSchema) {
		super();
		this.#outputSchema = outputSchema;
	}
};

//#endregion
export { OutputContext, RequestOutputContext };
//# sourceMappingURL=request-output-context.js.map